'use client';
import EcoImg from 'eco-design/base/eco-img';
import DefaultStyle from 'lowcode/common/DefaultStyle';
import { useEffect, useState } from 'react';
// import 'swiper/scss';
import styles from './index.module.scss';
import getLocal from '@/app/utils/i18n';

const icon1 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
        <g clipPath="url(#clip0_4830_4295)">
            <path
                d="M12.0204 21.8251C10.4208 21.9204 9.68192 22.7104 9.9121 23.2837C10.1442 23.857 11.7747 25.2969 14.5155 25.6816C17.2544 26.0663 19.9661 25.8907 21.001 25.8907C22.0338 25.8907 23.2562 25.7488 22.6257 25.2278C21.1595 24.0752 19.4927 23.1835 17.7031 22.5946C15.2989 21.8233 13.6181 21.7262 12.0204 21.8233V21.8251ZM6.32605 14.9601C6.43436 15.6287 7.15197 17.3319 9.22158 18.6242C10.8657 19.6551 12.7418 20.3928 14.7399 20.7887C16.2234 21.0912 17.6257 21.5039 17.1615 20.6636C16.6973 19.8232 15.1267 17.7371 12.856 16.2711C10.5852 14.8052 9.38789 14.6315 8.37825 14.426C7.36663 14.2206 6.21771 14.2953 6.32602 14.962L6.32605 14.9601ZM7.02237 8.05032C6.18871 8.05032 6.24482 8.79359 6.46727 9.43231C6.69163 10.0672 7.64519 11.9628 9.29122 13.1169C10.3898 13.8844 11.7806 14.5512 13.4633 15.1151C13.0881 13.0515 12.2834 11.4287 11.0494 10.2484C9.20029 8.47611 7.85602 8.0522 7.02237 8.0522V8.05032ZM10.7612 2.54862C10.4928 2.52356 10.2237 2.59032 10.0011 2.73724C9.89909 2.80352 9.81277 2.88985 9.74777 2.99059C9.68277 3.09133 9.64056 3.20419 9.6239 3.32178L9.58908 3.65046C9.49626 4.70746 9.66643 5.76822 10.0862 6.76922C10.7245 8.28191 11.6838 9.48271 12.9604 10.3642C13.2118 9.55742 13.3685 8.88885 13.4246 8.35474C13.5097 7.55171 13.5097 6.8271 12.9604 4.99508C12.7167 4.18082 12.1867 3.44502 11.3744 2.78767C11.1999 2.64971 10.986 2.56632 10.7612 2.54862Z"
                fill="url(#paint0_linear_4830_4295)"
            />
            <path
                d="M14.9986 0.260167C15.1859 0.263016 15.3761 0.324911 15.536 0.435047C15.671 0.525541 15.7776 0.646762 15.8418 0.78256C16.1358 1.42271 16.2275 2.00232 16.1142 2.51998C15.8601 3.68505 15.6236 4.06742 15.3082 4.46046C15.0987 4.72207 14.7824 5.0183 14.3616 5.35325C13.8502 4.42725 13.6415 3.44725 13.7357 2.41857C13.7997 1.7388 14.0394 1.11761 14.4425 0.593336L14.5716 0.432464C14.6204 0.376427 14.6837 0.332109 14.7573 0.302416C14.8309 0.272723 14.9131 0.258325 14.9986 0.260167Z"
                fill="url(#paint1_linear_4830_4295)"
            />
        </g>
        <defs>
            <linearGradient id="paint0_linear_4830_4295" x1="15.5281" y1="52.7339" x2="-2.78053" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <linearGradient id="paint1_linear_4830_4295" x1="15.5281" y1="52.7339" x2="-2.78053" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <clipPath id="clip0_4830_4295">
                <rect width="29" height="28" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
const icon2 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
        <g clipPath="url(#clip0_4830_4298)">
            <path
                d="M16.9803 21.8251C18.5799 21.9204 19.3188 22.7104 19.0886 23.2837C18.8565 23.857 17.226 25.2969 14.4852 25.6816C11.7463 26.0663 9.03456 25.8907 7.99975 25.8907C6.9669 25.8907 5.74447 25.7488 6.37501 25.2278C7.84119 24.0752 9.50801 23.1835 11.2976 22.5946C13.7018 21.8233 15.3826 21.7262 16.9803 21.8233V21.8251ZM22.6747 14.9601C22.5663 15.6287 21.8487 17.3319 19.7791 18.6242C18.135 19.6551 16.2589 20.3928 14.2608 20.7887C12.7773 21.0912 11.375 21.5039 11.8392 20.6636C12.3034 19.8232 13.874 17.7371 16.1447 16.2711C18.4155 14.8052 19.6128 14.6315 20.6225 14.426C21.6341 14.2206 22.783 14.2953 22.6747 14.962L22.6747 14.9601ZM21.9783 8.05032C22.812 8.05032 22.7559 8.79359 22.5334 9.43231C22.3091 10.0672 21.3555 11.9628 19.7095 13.1169C18.6109 13.8844 17.2201 14.5512 15.5374 15.1151C15.9126 13.0515 16.7173 11.4287 17.9513 10.2484C19.8004 8.47611 21.1447 8.0522 21.9783 8.0522V8.05032ZM18.2395 2.54862C18.5079 2.52356 18.777 2.59032 18.9996 2.73724C19.1016 2.80352 19.1879 2.88985 19.2529 2.99059C19.3179 3.09133 19.3601 3.20419 19.3768 3.32178L19.4116 3.65046C19.5044 4.70746 19.3343 5.76822 18.9145 6.76922C18.2762 8.28191 17.3169 9.48271 16.0403 10.3642C15.7889 9.55742 15.6322 8.88885 15.5761 8.35474C15.491 7.55171 15.491 6.8271 16.0403 4.99508C16.284 4.18082 16.814 3.44502 17.6263 2.78767C17.8008 2.64971 18.0147 2.56632 18.2395 2.54862Z"
                fill="url(#paint0_linear_4830_4298)"
            />
            <path
                d="M14.0022 0.260167C13.8148 0.263016 13.6246 0.324911 13.4647 0.435047C13.3298 0.525541 13.2231 0.646762 13.1589 0.78256C12.8649 1.42271 12.7733 2.00232 12.8865 2.51998C13.1406 3.68505 13.3771 4.06742 13.6925 4.46046C13.902 4.72207 14.2183 5.0183 14.6391 5.35325C15.1505 4.42725 15.3592 3.44725 15.265 2.41857C15.201 1.7388 14.9613 1.11761 14.5582 0.593336L14.4291 0.432464C14.3803 0.376427 14.317 0.332109 14.2434 0.302416C14.1698 0.272723 14.0876 0.258325 14.0022 0.260167Z"
                fill="url(#paint1_linear_4830_4298)"
            />
        </g>
        <defs>
            <linearGradient id="paint0_linear_4830_4298" x1="15.4114" y1="52.7339" x2="-2.89717" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <linearGradient id="paint1_linear_4830_4298" x1="15.4114" y1="52.7339" x2="-2.89717" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <clipPath id="clip0_4830_4298">
                <rect width="29" height="28" fill="white" transform="matrix(-1 0 0 1 28.9998 0.00012207)" />
            </clipPath>
        </defs>
    </svg>
);
const icon3 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="52" viewBox="0 0 54 52" fill="none">
        <path
            d="M22.3267 40.5344C19.3561 40.7113 17.9839 42.1784 18.4114 43.2431C18.8424 44.3078 21.8705 46.9819 26.9606 47.6963C32.047 48.4108 37.0831 48.0848 39.0049 48.0848C40.9231 48.0848 43.1933 47.8212 42.0223 46.8536C39.2994 44.713 36.2039 43.0571 32.8804 41.9633C28.4154 40.5309 25.2939 40.3506 22.3267 40.5309V40.5344ZM11.7515 27.7851C11.9527 29.0268 13.2854 32.1898 17.129 34.5898C20.1823 36.5043 23.6666 37.8742 27.3773 38.6095C30.1324 39.1713 32.7367 39.9379 31.8746 38.3772C31.0125 36.8165 28.0957 32.9424 23.8785 30.2198C19.6613 27.4973 17.4378 27.1747 15.5628 26.7932C13.6841 26.4117 11.5503 26.5504 11.7515 27.7886L11.7515 27.7851ZM13.0447 14.9526C11.4965 14.9526 11.6007 16.3329 12.0138 17.5191C12.4305 18.6983 14.2014 22.2186 17.2583 24.3619C19.2986 25.7874 21.8813 27.0256 25.0065 28.073C24.3096 24.2406 22.8152 21.2267 20.5235 19.0347C17.0894 15.7433 14.5929 14.9561 13.0447 14.9561V14.9526ZM19.9883 4.73513C19.4897 4.68859 18.9901 4.81257 18.5766 5.08544C18.3872 5.20852 18.2269 5.36886 18.1062 5.55594C17.9855 5.74302 17.9071 5.95263 17.8761 6.17101L17.8114 6.78141C17.6391 8.74442 17.9551 10.7144 18.7346 12.5734C19.92 15.3827 21.7017 17.6127 24.0725 19.2497C24.5394 17.7515 24.8304 16.5099 24.9346 15.5179C25.0927 14.0266 25.0927 12.6809 24.0725 9.27856C23.6199 7.76637 22.6357 6.39988 21.127 5.17909C20.803 4.92287 20.4057 4.76802 19.9883 4.73513Z"
            fill="url(#paint0_linear_826_52267)"
        />
        <path
            d="M27.8576 0.485154C28.2056 0.490446 28.5588 0.605394 28.8557 0.809933C29.1064 0.977993 29.3045 1.20312 29.4237 1.45531C29.9697 2.64416 30.1399 3.72058 29.9296 4.68196C29.4577 6.84565 29.0184 7.55578 28.4326 8.2857C28.0436 8.77154 27.4562 9.32169 26.6748 9.94374C25.7249 8.22402 25.3374 6.40401 25.5123 4.49361C25.6311 3.23119 26.0763 2.07755 26.825 1.1039L27.0647 0.805136C27.1554 0.701067 27.2729 0.618762 27.4095 0.563618C27.5462 0.508474 27.6989 0.481735 27.8576 0.485154Z"
            fill="url(#paint1_linear_826_52267)"
        />
        <defs>
            <linearGradient id="paint0_linear_826_52267" x1="28.841" y1="97.9364" x2="-24.8821" y2="-14.9735" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#EAB160" />
                <stop offset="0.870192" stopColor="#AC6803" />
            </linearGradient>
            <linearGradient id="paint1_linear_826_52267" x1="28.841" y1="97.9364" x2="-24.8821" y2="-14.9735" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#EAB160" />
                <stop offset="0.870192" stopColor="#AC6803" />
            </linearGradient>
        </defs>
    </svg>
);
const icon4 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="52" viewBox="0 0 54 52" fill="none">
        <path
            d="M31.5307 40.5344C34.5014 40.7113 35.8735 42.1784 35.4461 43.2431C35.015 44.3078 31.9869 46.9819 26.8969 47.6963C21.8104 48.4108 16.7743 48.0848 14.8525 48.0848C12.9343 48.0848 10.6641 47.8212 11.8351 46.8536C14.558 44.713 17.6535 43.0571 20.9771 41.9633C25.442 40.5309 28.5636 40.3506 31.5307 40.5309V40.5344ZM42.1059 27.7851C41.9047 29.0268 40.572 32.1898 36.7285 34.5898C33.6752 36.5043 30.1908 37.8742 26.4801 38.6095C23.725 39.1713 21.1207 39.9379 21.9828 38.3772C22.8449 36.8165 25.7618 32.9424 29.9789 30.2198C34.1961 27.4973 36.4196 27.1747 38.2947 26.7932C40.1734 26.4117 42.3071 26.5504 42.1059 27.7886L42.1059 27.7851ZM40.8127 14.9526C42.3609 14.9526 42.2567 16.3329 41.8436 17.5191C41.4269 18.6983 39.656 22.2186 36.5991 24.3619C34.5589 25.7874 31.9761 27.0256 28.851 28.073C29.5478 24.2406 31.0422 21.2267 33.3339 19.0347C36.768 15.7433 39.2645 14.9561 40.8127 14.9561V14.9526ZM33.8692 4.73513C34.3677 4.68859 34.8673 4.81257 35.2808 5.08544C35.4702 5.20852 35.6305 5.36886 35.7512 5.55594C35.872 5.74302 35.9504 5.95263 35.9813 6.17101L36.046 6.78141C36.2184 8.74442 35.9023 10.7144 35.1228 12.5734C33.9374 15.3827 32.1557 17.6127 29.785 19.2497C29.318 17.7515 29.027 16.5099 28.9228 15.5179C28.7648 14.0266 28.7648 12.6809 29.7849 9.27856C30.2375 7.76637 31.2218 6.39988 32.7304 5.17909C33.0545 4.92287 33.4517 4.76802 33.8692 4.73513Z"
            fill="url(#paint0_linear_826_52274)"
        />
        <path
            d="M25.9998 0.485154C25.6519 0.490446 25.2986 0.605394 25.0017 0.809933C24.7511 0.977993 24.5529 1.20312 24.4337 1.45531C23.8877 2.64416 23.7176 3.72058 23.9278 4.68196C24.3998 6.84565 24.839 7.55578 25.4248 8.2857C25.8138 8.77154 26.4013 9.32169 27.1827 9.94374C28.1325 8.22402 28.52 6.40401 28.3451 4.49361C28.2263 3.23119 27.7811 2.07755 27.0324 1.1039L26.7927 0.805136C26.702 0.701067 26.5845 0.618762 26.4479 0.563618C26.3112 0.508474 26.1585 0.481735 25.9998 0.485154Z"
            fill="url(#paint1_linear_826_52274)"
        />
        <defs>
            <linearGradient id="paint0_linear_826_52274" x1="25.0164" y1="97.9364" x2="78.7395" y2="-14.9735" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#EAB160" />
                <stop offset="0.870192" stopColor="#AC6803" />
            </linearGradient>
            <linearGradient id="paint1_linear_826_52274" x1="25.0164" y1="97.9364" x2="78.7395" y2="-14.9735" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#EAB160" />
                <stop offset="0.870192" stopColor="#AC6803" />
            </linearGradient>
        </defs>
    </svg>
);
export default function Content({ id, data, attr, theme }: any) {
    let { title1, title2, title3, list = [], pc, h5, bg = 'lightgray', footerText } = data;
    // 最多6个
    const newList = list.slice(0, 7);
    const [isBr, setIsBr] = useState(false);
    const [hasSrc, setHasSrc] = useState(pc);
    const [titleLength, setTitleLength] = useState<number>(0);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW > 1440) {
                    // pc
                    setIsBr(false);
                    setHasSrc(pc);
                } else {
                    setIsBr(true);
                    setHasSrc(h5);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, [pc, h5]);
    useEffect(() => {
        const number = [title1.length, title2.length, title3.length].reduce((accumulator, currentValue) => {
            return accumulator + currentValue;
        }, 0);
        setTitleLength(number);
    }, [title1, title2, title3]);

    const { locale = 'us' } = getLocal();
    if (locale === 'jp') {
        return (
            <div
                className={`${styles.contentJP} temp-SwiperCardB temp-hide temp-${theme} temp-${id} GtmModuleData-section`}
                id={id}
                data-section-id="editor-SwiperCardB"
                data-section-id2={id}
                data-section-classname=".SwiperCardB-title"
                style={{ backgroundImage: `url(${hasSrc})`, backgroundColor: bg }}
            >
                <div className="content-box">
                    {(title1 || title2 || title3) && (
                        <h1 className="SwiperCardB-title">
                            <span className="title1">{title1}</span>
                            <span className="title2">
                                {icon3}
                                {title2}
                                {icon4}
                            </span>
                            <br></br>
                            <span className="title3">{title3}</span>
                        </h1>
                    )}
                    <div className={`box box-${newList.length}`}>
                        {newList?.map((item: any, index: number) => {
                            const { label, title, desc } = item;
                            return (
                                <div className="item" key={index}>
                                    <div className="item-label">{label}</div>
                                    <div className="item-title">{title}</div>
                                    <div className="item-desc">{desc}</div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="footer-text">{footerText}</div>
                </div>
            </div>
        );
    }
    return (
        <div
            className={`${styles.content} temp-SwiperCardB temp-hide temp-${theme} temp-${id} GtmModuleData-section`}
            id={id}
            data-section-id="editor-SwiperCardB"
            data-section-id2={id}
            data-section-classname=".SwiperCardB-title"
            style={{ backgroundImage: `url(${hasSrc})`, backgroundColor: bg }}
        >
            <div className="content-box">
                <DefaultStyle id={id} attr={attr} />
                {(title1 || title2 || title3) && (
                    <h1 className="SwiperCardB-title">
                        <span className="title1">{title1}</span>
                        <span className="title2">
                            {icon1}
                            {title2}
                            {icon2}
                        </span>
                        {(isBr || titleLength > 50) && <br></br>}
                        <span className="title3">{title3}</span>
                    </h1>
                )}
                <div className={`box box-${newList.length}`}>
                    {newList?.map((item: any, index: number) => {
                        const { label, title, desc } = item;
                        return (
                            <div className="item" key={index}>
                                <div className="item-label">{label}</div>
                                <div className="item-title">{title}</div>
                                <div className="item-desc">{desc}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
